import { createContext, PropsWithChildren, useContext } from 'react';
import { UseInertiaFormProps } from 'use-inertia-form';

export const FormContext = createContext<UseInertiaFormProps<unknown> | null>(null);

export const FormProvider = ({ value, children }: PropsWithChildren<{ value: UseInertiaFormProps<unknown> }>) => {
    return (
        <FormContext.Provider value={value}>
            {children}
        </FormContext.Provider>
    );
};

export const useForm = () => useContext(FormContext);
